import React, { useState } from 'react';
import './Login.css';

const loginTranslations = {
  es: {
    title: 'Acceso a la Aplicación',
    subtitle: 'Ingresa tus credenciales para continuar',
    user: 'Usuario',
    password: 'Contraseña',
    login: 'Iniciar Sesión',
    noAccess: '¿No tienes acceso?',
    request: 'Solicita acceso aquí',
    contact: 'O envía un correo a:',
    errorEmpty: 'Por favor, ingresa usuario y contraseña',
    errorInvalid: 'Credenciales inválidas',
    language: 'Idioma',
    infoText: 'Bienvenido a la plataforma para terapia de EMDR. Esta aplicación tiene como objetivo ofrecer un servicio gratuito, seguro, multilenguaje y libre de virus, orientado al apoyo terapéutico y al desarrollo clínico responsable. Toda la información es tratada de manera confidencial. Tus comentarios y sugerencias son fundamentales para seguir mejorando esta herramienta.'
  },
  en: {
    title: 'Application Access',
    subtitle: 'Enter your credentials to continue',
    user: 'User',
    password: 'Password',
    login: 'Sign In',
    noAccess: 'No access?',
    request: 'Request access here',
    contact: 'Or email:',
    errorEmpty: 'Please enter username and password',
    errorInvalid: 'Credenciales inválidas',
    language: 'Language',
    infoText: 'Welcome to the EMDR platform. This application aims to provide a free, secure, multilingual, virus-free service focused on therapeutic support and responsible clinical development. All information is treated confidentially. Your comments and suggestions are essential to keep improving this tool.'
  },
  ar: {
    title: 'الوصول إلى التطبيق',
    subtitle: 'أدخل بياناتك للمتابعة',
    user: 'المستخدم',
    password: 'كلمة المرور',
    login: 'تسجيل الدخول',
    noAccess: 'لا تملك وصولاً؟',
    request: 'اطلب الوصول هنا',
    contact: 'أو أرسل بريدًا إلى:',
    errorEmpty: 'يرجى إدخال اسم المستخدم وكلمة المرور',
    errorInvalid: 'Credenciales inválidas',
    language: 'اللغة',
    infoText: 'مرحبًا بك في منصة EMDR. يهدف هذا التطبيق إلى تقديم خدمة مجانية وآمنة ومتعددة اللغات وخالية من الفيروسات، موجهة للدعم العلاجي والتطوير السريري المسؤول. يتم التعامل مع جميع المعلومات بسرية. تعليقاتك واقتراحاتك أساسية لمواصلة تحسين هذه الأداة.'
  },
  fr: {
    title: 'Accès à l’application',
    subtitle: 'Entrez vos identifiants pour continuer',
    user: 'Utilisateur',
    password: 'Mot de passe',
    login: 'Se connecter',
    noAccess: 'Pas d’accès ?',
    request: 'Demander l’accès ici',
    contact: 'Ou envoyez un email à :',
    errorEmpty: 'Veuillez saisir l’utilisateur et le mot de passe',
    errorInvalid: 'Credenciales inválidas',
    language: 'Langue',
    infoText: 'Bienvenue sur la plateforme EMDR. Cette application vise à offrir un service gratuit, sécurisé, multilingue et sans virus, orienté vers le soutien thérapeutique et le développement clinique responsable. Toutes les informations sont traitées de manière confidentielle. Vos commentaires et suggestions sont essentiels pour continuer à améliorer cet outil.'
  },
  pt: {
    title: 'Acesso ao Aplicativo',
    subtitle: 'Insira suas credenciais para continuar',
    user: 'Usuário',
    password: 'Senha',
    login: 'Entrar',
    noAccess: 'Sem acesso?',
    request: 'Solicite acesso aqui',
    contact: 'Ou envie um email para:',
    errorEmpty: 'Por favor, insira usuário e senha',
    errorInvalid: 'Credenciales inválidas',
    language: 'Idioma',
    infoText: 'Bem-vindo à plataforma EMDR. Este aplicativo tem como objetivo oferecer um serviço gratuito, seguro, multilíngue e livre de vírus, voltado ao apoio terapêutico e ao desenvolvimento clínico responsável. Todas as informações são tratadas de forma confidencial. Seus comentários e sugestões são fundamentais para continuar melhorando esta ferramenta.'
  },
  de: {
    title: 'Zugang zur App',
    subtitle: 'Bitte Zugangsdaten eingeben',
    user: 'Benutzer',
    password: 'Passwort',
    login: 'Anmelden',
    noAccess: 'Kein Zugang?',
    request: 'Zugang anfordern',
    contact: 'Oder E-Mail an:',
    errorEmpty: 'Bitte Benutzer und Passwort eingeben',
    errorInvalid: 'Credenciales inválidas',
    language: 'Sprache',
    infoText: 'Willkommen auf der EMDR-Plattform. Diese Anwendung bietet einen kostenlosen, sicheren, mehrsprachigen und virenfreien Service für therapeutische Unterstützung und verantwortungsvolle klinische Entwicklung. Alle Informationen werden vertraulich behandelt. Ihre Kommentare und Vorschläge sind entscheidend, um dieses Tool weiter zu verbessern.'
  },
  pl: {
    title: 'Dostęp do aplikacji',
    subtitle: 'Wpisz dane logowania',
    user: 'Użytkownik',
    password: 'Hasło',
    login: 'Zaloguj',
    noAccess: 'Brak dostępu?',
    request: 'Poproś o dostęp',
    contact: 'Lub napisz e-mail:',
    errorEmpty: 'Wpisz użytkownika i hasło',
    errorInvalid: 'Credenciales inválidas',
    language: 'Język',
    infoText: 'Witamy na platformie EMDR. Ta aplikacja ma na celu zapewnienie bezpłatnej, bezpiecznej, wielojęzycznej i wolnej od wirusów usługi, ukierunkowanej na wsparcie terapeutyczne i odpowiedzialny rozwój kliniczny. Wszystkie informacje są traktowane poufnie. Twoje komentarze i sugestie są kluczowe, aby dalej ulepszać to narzędzie.'
  },
  it: {
    title: 'Accesso all’app',
    subtitle: 'Inserisci le credenziali',
    user: 'Utente',
    password: 'Password',
    login: 'Accedi',
    noAccess: 'Senza accesso?',
    request: 'Richiedi accesso',
    contact: 'Oppure invia un’email a:',
    errorEmpty: 'Inserisci utente e password',
    errorInvalid: 'Credenciales inválidas',
    language: 'Lingua',
    infoText: 'Benvenuto sulla piattaforma EMDR. Questa applicazione mira a offrire un servizio gratuito, sicuro, multilingue e privo di virus, orientato al supporto terapeutico e allo sviluppo clinico responsabile. Tutte le informazioni sono trattate in modo confidenziale. I tuoi commenti e suggerimenti sono fondamentali per continuare a migliorare questo strumento.'
  },
  ko: {
    title: '앱 접근',
    subtitle: '자격 증명을 입력하세요',
    user: '사용자',
    password: '비밀번호',
    login: '로그인',
    noAccess: '접근 권한이 없나요?',
    request: '접근 요청',
    contact: '또는 이메일:',
    errorEmpty: '사용자와 비밀번호를 입력하세요',
    errorInvalid: 'Credenciales inválidas',
    language: '언어',
    infoText: 'EMDR 플랫폼에 오신 것을 환영합니다. 이 앱은 무료이며 안전하고 다국어를 지원하며 바이러스가 없는 서비스를 제공하여 치료적 지원과 책임 있는 임상 개발을 돕는 것을 목표로 합니다. 모든 정보는 기밀로 처리됩니다. 여러분의 의견과 제안은 이 도구를 계속 개선하는 데 매우 중요합니다.'
  },
  zh: {
    title: '应用访问',
    subtitle: '请输入您的凭据',
    user: '用户',
    password: '密码',
    login: '登录',
    noAccess: '没有访问权限？',
    request: '申请访问',
    contact: '或发送邮件至：',
    errorEmpty: '请输入用户名和密码',
    errorInvalid: 'Credenciales inválidas',
    language: '语言',
    infoText: '欢迎来到 EMDR 平台。本应用旨在提供免费、安全、多语言、无病毒的服务，支持治疗并促进负责任的临床发展。所有信息均保密处理。您的意见和建议对于持续改进该工具至关重要。'
  },
  ja: {
    title: 'アプリへのアクセス',
    subtitle: '資格情報を入力してください',
    user: 'ユーザー',
    password: 'パスワード',
    login: 'ログイン',
    noAccess: 'アクセス権がありませんか？',
    request: 'アクセスを申請',
    contact: 'またはメール：',
    errorEmpty: 'ユーザー名とパスワードを入力してください',
    errorInvalid: 'Credenciales inválidas',
    language: '言語',
    infoText: 'EMDRプラットフォームへようこそ。本アプリは、無料で安全かつ多言語対応、ウイルスのないサービスを提供し、治療的支援と責任ある臨床開発を目的としています。すべての情報は機密として扱われます。ご意見やご提案は、このツールの改善に不可欠です。'
  },
  he: {
    title: 'גישה לאפליקציה',
    subtitle: 'הזן את פרטי ההתחברות',
    user: 'משתמש',
    password: 'סיסמה',
    login: 'התחבר',
    noAccess: 'אין גישה?',
    request: 'בקש גישה',
    contact: 'או שלח מייל אל:',
    errorEmpty: 'אנא הזן משתמש וסיסמה',
    errorInvalid: 'Credenciales inválidas',
    language: 'שפה',
    infoText: 'ברוכים הבאים לפלטפורמת EMDR. יישום זה נועד להציע שירות חינמי, מאובטח, רב־לשוני ונטול וירוסים, המכוון לתמיכה טיפולית ולפיתוח קליני אחראי. כל המידע מטופל באופן חסוי. ההערות וההצעות שלך חיוניות להמשך שיפור הכלי.'
  },
  ru: {
    title: 'Доступ к приложению',
    subtitle: 'Введите данные для входа',
    user: 'Пользователь',
    password: 'Пароль',
    login: 'Войти',
    noAccess: 'Нет доступа?',
    request: 'Запросить доступ',
    contact: 'Или напишите на:',
    errorEmpty: 'Введите пользователя и пароль',
    errorInvalid: 'Credenciales inválidas',
    language: 'Язык',
    infoText: 'Добро пожаловать на платформу EMDR. Это приложение предназначено для предоставления бесплатного, безопасного, многоязычного и свободного от вирусов сервиса, направленного на терапевтическую поддержку и ответственное клиническое развитие. Вся информация обрабатывается конфиденциально. Ваши комментарии и предложения крайне важны для дальнейшего улучшения этого инструмента.'
  }
};

const Login = ({ onLogin, language = 'es', onLanguageChange }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showRequestAccess, setShowRequestAccess] = useState(false);
  const t = loginTranslations[language] || loginTranslations.es;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validar que se ingresen usuario y contraseña
    if (username.trim() === '' || password.trim() === '') {
      setError(t.errorEmpty);
      return;
    }

    const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    const trimmedUsername = username.trim().toLowerCase();
    const trimmedPassword = password.trim();

    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({username: trimmedUsername, password: trimmedPassword}),
      });

      if (!response.ok) {
        setError(t.errorInvalid);
        return;
      }

      const data = await response.json();
      if (!data || !data.token) {
        setError(t.errorInvalid);
        return;
      }

      onLogin({token: data.token, username: data.user?.username || trimmedUsername});
    } catch (error) {
      setError(t.errorInvalid);
    }
  };

  const handleRequestAccess = () => {
    const subject = encodeURIComponent('Solicitud de acceso a APP EMDR');
    const body = encodeURIComponent(`Hola,\n\nMe gustaría solicitar acceso a la aplicación EMDR.\n\nNombre: [Tu nombre]\nMotivo: [Tu motivo]\n\nGracias.`);
    window.location.href = `mailto:login_app@pspenafielphd.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">{t.title}</h2>
        <p className="login-subtitle">{t.subtitle}</p>
        <div className="login-info">
          <p>{t.infoText}</p>
        </div>
        <div className="login-language">
          <label>
            <span className="login-language-icon" aria-hidden="true">🌐</span>
            {t.language}
            <select
              value={language}
              onChange={(e) => onLanguageChange && onLanguageChange(e.target.value)}
            >
              <option value="es">Español</option>
              <option value="en">English</option>
              <option value="ar">العربية</option>
              <option value="fr">Français</option>
              <option value="pt">Português</option>
              <option value="de">Deutsch</option>
              <option value="pl">Polski</option>
              <option value="it">Italiano</option>
              <option value="ko">한국어</option>
              <option value="zh">中文</option>
              <option value="ja">日本語</option>
              <option value="he">עברית</option>
              <option value="ru">Русский</option>
            </select>
          </label>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">{t.user}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingresa tu usuario"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t.password}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button">
            {t.login}
          </button>
        </form>

        <div className="login-footer">
          <p className="access-request-text">
            {t.noAccess}{' '}
            <button 
              type="button" 
              className="request-access-button"
              onClick={handleRequestAccess}
            >
              {t.request}
            </button>
          </p>
          <p className="contact-email">
            {t.contact}{' '}
            <a href="mailto:login_app@pspenafielphd.com?subject=Solicitud de acceso a APP EMDR">
              login_app@pspenafielphd.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
